'use client';

import {useAuth} from "@/context/auth.context";
import {resendVerificationAction} from "@/app/actions/auth";
import {useState} from "react";
import {useCookies} from "react-cookie";

export default function VerifyAccount() {
    const {user} = useAuth();
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);
    const [failed, setFailed] = useState(false);
    const [cookies, setCookies] = useCookies(["verification"]);

    if (user && user.email_verified_at == null) {
        const handleResend = () => {
            setLoading(true);
            resendVerificationAction()
                .then(() => {
                    setCookies("verification", 1, { path: '/', secure: true, sameSite: 'lax' });
                    setSent(true);
                })
                .catch(() => {
                    setFailed(true);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        if (loading) {
            return (
                <div className="eo-actionPing">
                    <div className="actionPing-main">
                        <div className="actionPing-message">
                            <div className={"eo-spinner-box"}>
                                <span className={"eo-spinner sz-sm"}></span>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        if (failed) {
            return (
                <div className="eo-actionPing">
                    <div className="actionPing-main">
                        <div className="actionPing-message">
                            There was a problem sending the verification email. Try again later.
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="eo-actionPing">
                <div className="actionPing-main">
                    {sent || cookies.verification == 1 ?
                        <>
                            <div className="actionPing-message">
                                Check your email inbox for the account verification email
                            </div>
                        </>
                        :
                        <>
                            <div className="actionPing-message">
                                Please confirm your email address by clicking the link in your Welcome email.
                            </div>
                            <div className="actionPing-secondary">
                                <a onClick={handleResend} style={{cursor: "pointer"}}>Can&apos;t find the email? Resend Now</a>
                            </div>
                        </>
                    }

                </div>
            </div>
        )
    }

    return null;
}
